import { BaseError, type BaseErrorParameters } from './base';

export class UnauthorizedError extends BaseError {
  constructor({ cause }: Pick<BaseErrorParameters, 'cause'>) {
    super({
      cause,
      code: 'unauthorized_error',
      docsUrl: null,
      name: 'UnauthorizedError',
      shortMessage: 'Unauthorized',
    });
  }
}
